type Axis = { min: number; max: number; ticks: number[] }

function niceStep(value: number): number {
  const magnitude = 10 ** Math.floor(Math.log10(value))
  const fraction = value / magnitude
  return ([1, 2, 2.5, 5, 10].find(step => step >= fraction) ?? 10) * magnitude
}

// Call with the finite carry/offline pairs actually displayed in the chart.
export function dispersionAxes(points: ReadonlyArray<{ carry: number; offline: number }>): { carry: Axis; offline: Axis } {
  let carryMin = points[0]?.carry ?? 0
  let carryMax = carryMin
  let offlineMax = 0
  for (const point of points) {
    carryMin = Math.min(carryMin, point.carry)
    carryMax = Math.max(carryMax, point.carry)
    offlineMax = Math.max(offlineMax, Math.abs(point.offline))
  }

  // Two yards of minimum padding keeps single shots and identical values legible.
  const padding = Math.max(2, (carryMax - carryMin) * 0.1)
  const min = carryMin - padding
  const max = carryMax + padding
  const step = niceStep((max - min) / 6)
  const firstTick = Math.ceil(min / step)
  const lastTick = Math.floor(max / step)
  const ticks = Array.from({ length: lastTick - firstTick + 1 }, (_, index) => Number(((firstTick + index) * step).toFixed(6)))
  const extent = niceStep(Math.max(5, offlineMax + Math.max(1, offlineMax * 0.1)))

  return {
    carry: { min, max, ticks },
    offline: { min: -extent, max: extent, ticks: [-extent, -extent / 2, 0, extent / 2, extent] },
  }
}
